<template>
  <div>
    <!-- <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange" /> -->
    <a-tree
      class="draggable-tree"
      :defaultExpandedKeys="expandedKeys"
      :expandedKeys="expandedKeys"
      :autoExpandParent="autoExpandParent"
      draggable
      @expand="onExpand"
      @select="onSelect"
      :treeData="gData"
      ref="nodes"
    >
      <template slot="title" slot-scope="{ title }">
        <span v-if="title.indexOf(searchValue) > -1">
          {{ title.substr(0, title.indexOf(searchValue)) }}
          <span style="color: #f50">{{ searchValue }}</span>
          {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
        </span>
        <span v-else>{{ title }} </span>
      </template>
    </a-tree>
  </div>
</template>

<script>
import HTTPRequest from "../controllers/httpRequest.js";
import { mapState } from "vuex";

let gData = [];
const dataList = [];
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const key = node.key;
    dataList.push({ key, title: node.title });
    if (node.children) {
      generateList(node.children, node.key);
    }
  }
};

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

let node_ret = null;
const getNode = function (key, tree) {
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.key == key) {
      node_ret = node;
    } else {
      if (node.children.length > 0) {
        getNode(key, node.children);
      }
    }
  }
  return node_ret;
};

export default {
  mounted: async function () {
    this.gData = await HTTPRequest.getRequest(
      this.endPoint +
        "/terminal_settings_categories/tree_view?header_id=" +
        this.$attrs.headerId,
      null
    );
    generateList(this.gData);

    if (this.$attrs.defaultSelected == true) {
      var selectedTreeNode = getNode(this.gData[0].key, this.gData);
      if (selectedTreeNode.children.length > 0) {
        selectedTreeNode = getNode(this.gData[0].children[0].key, this.gData);
      }
      this.$emit("selectNode", selectedTreeNode);
    }

    // if(document.getElementsByClassName("draggable-tree")[0].children[0].children.length == 2){
    //     document.getElementsByClassName("draggable-tree")[0].children[0].children[0].click()
    // }
  },
  data() {
    return {
      defaultExpandAll: true,
      checkedValues: [],
      expandedKeys: [],
      autoExpandParent: true,
      gData,
      //   visible: false,
      //   formId: "",
      selectedNode: null,
      selectedKey: null,
      selectedTitle: "",
      selectedCode: "",
      selectedRefCode: "",
      showLine: true,
      searchValue: ''
    };
  },
  //   watch: {
  //       gData: function() {
  //         var selectedTreeNode = getNode(this.gData[0].key, this.gData)
  //         if(selectedTreeNode.children.length > 0){
  //             selectedTreeNode = getNode(this.gData[0].children[0].key, this.gData)
  //         }
  //         this.$emit("selectNode", selectedTreeNode)
  //       }
  //   },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
    // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType']
  },
  methods: {
    // TREE FUNCTIONS
    onExpand(expandedKeys) {
      this.selectedNode = null;
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onChange(e) {
      const value = e.target.value;
      const expandedKeys = dataList
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, gData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      });
    },
    async onSelect(info) {
      // console.log(this.gData)
      // console.log(">>>>>>")
      // console.log(info[0])
      // console.log(document.getElementsByClassName("draggable-tree")[0])
      var selectedNode = getNode(info[0], this.gData);
      this.$emit("selectNode", selectedNode);
      // this.selectedNode = selectedNode
      // this.selectedKey = selectedNode.key
      // this.selectedCode = selectedNode.scopedSlots.code
      // this.selectedRefCode = selectedNode.scopedSlots.reference_code
      // this.selectedTitle = selectedNode.title
      // this.jsonField = selectedNode.scopedSlots.settings_template
    },
  },
};
</script>
